import * as pageFilterActions from '../actions/page-filter.actions';
import { createReducer, on, Action } from '@ngrx/store';
import { setActiveCompany } from '@core/auth/@store/user/user.actions';
import { AssignmentApiModel } from 'app/models/assignment-api.model';

export interface State {
  deliveriesPage: AssignmentApiModel;
}

export const initialState: State = {
  deliveriesPage: null,
};

const featureReducer = createReducer(
  initialState,
  on(pageFilterActions.updateDeliveriesPageFilter, (state, props) => {
    return {
      ...state,
      deliveriesPage: props.deliveriesPage,
    };
  }),
  on(pageFilterActions.resetDeliveriesPageFilter, (state) => {
    return {
      ...state,
      deliveriesPage: initialState.deliveriesPage,
    };
  }),
  on(setActiveCompany, (state) => initialState)
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
